import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const articleLinks = [
  { label: 'Complete Guide', to: '/article/basetao-spreadsheet-guide' },
  { label: 'Basetao Review', to: '/article/basetao-review' },
  { label: 'Is Basetao Legit?', to: '/article/is-basetao-legit' },
  { label: 'Shipping Cost', to: '/article/basetao-shipping-cost' },
  { label: 'Coupon Guide', to: '/article/basetao-coupon-guide' },
  { label: 'Warehouse Guide', to: '/article/basetao-warehouse-guide' },
  { label: 'vs Superbuy', to: '/article/basetao-vs-superbuy' },
  { label: 'Beginner Guide', to: '/article/basetao-beginner-guide' },
  { label: 'Tutorial', to: '/article/basetao-spreadsheet-tutorial' },
  { label: 'Alternatives', to: '/article/basetao-alternatives' },
  { label: 'Buying Guide', to: '/article/basetao-buying-guide' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-semibold text-foreground-900 tracking-tight">
                Basetao <span className="text-primary-500">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Your complete resource for Basetao spreadsheet finds, product categories, shipping guides, and smart shopping strategies.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Product Categories</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Guides & Articles</h4>
            <ul className="space-y-2">
              {articleLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Sheet. All external product links go to{' '}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-primary-500 hover:text-primary-600 underline"
            >
              kaspreadsheet.com
            </a>
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
              Home
            </Link>
            <Link to="/article/basetao-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">
              Complete Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}